<template src="./TextBox.html"></template>
<style src="./TextBox.css" scoped></style>

<script>
export default {
  name: 'TextBox'
}
</script>
